"use client";

import { cn } from "@/components/libs/cn";
import { useCommonTranslation } from "@/features/i18n/libs/useCommonTranslation";

type LogoProps = {
  className?: string;
  variant?: "default" | "small" | "tiny";
  colored?: boolean;
  font?: "nunito" | "nunitoSans";
};

export function Logo({
  className,
  variant = "default",
  colored = false,
  font = "nunito",
}: LogoProps) {
  const { t } = useCommonTranslation();

  const isSmall = variant === "small";
  const isTiny = variant === "tiny";

  return (
    <a
      href="/"
      className={cn(
        font === "nunitoSans" ? "font-nunitoSans" : "font-nunito",
        isSmall || isTiny
          ? "flex items-center gap-2 w-full justify-center"
          : "mb-6 flex flex-col items-center gap-1",
        className,
      )}
    >
      <div className={"flex items-center gap-2"}>
        <img
          src="/icons/logo.svg"
          alt="Pyramid"
          width={isSmall ? 32 : isTiny ? 24 : 45}
          height={isSmall ? 30 : isTiny ? 22 : 42}
        />
        <h1
          className={cn(
            isTiny
              ? "text-xs"
              : isSmall
                ? "text-lg font-bold"
                : "text-[22px] font-bold leading-[32px]",
            colored &&
              "bg-gradient-to-b from-[#E67E22] to-[#E74C3C] bg-clip-text text-transparent font-extrabold text-[22px]",
          )}
        >
          {t("common:brand_name")}
        </h1>
      </div>
      {!isSmall && !isTiny && (
        <div className="text-center text-text-secondary">
          {t("common:child_development_assistance")}
        </div>
      )}
    </a>
  );
}
